import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "45y4w8yv", 
  dataset: "production", 
  useCdn: false
});